import { useDecision } from '@optimizely/react-sdk';

import { FeatureFlags, WorkflowUxVariables } from '@frontend/constants/featureFlags';

export function useWorkflowUx() {
  const [decision] = useDecision(FeatureFlags.WORKFLOW_UX);
  const vars = decision?.variables;

  return {
    combineAgentLogs: Boolean(vars?.[WorkflowUxVariables.COMBINE_AGENT_LOGS]),
    naturalLanguageConditions: Boolean(vars?.[WorkflowUxVariables.NATURAL_LANGUAGE_CONDITIONS]),
    revampedNavigationLayout: Boolean(vars?.[WorkflowUxVariables.REVAMPED_NAVIGATION_LAYOUT]),
  };
}
